<template>
  <div class="account-page container">
    <div class="columns">
      <div class="column is-four-fifths">
        <h1 class="purple">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="43"
            viewBox="0 0 42.7 43.1"
          >
            <!-- eslint-disable-next-line max-len -->
            <path
              class="st0"
              d="M23 43.1h-3.4c-0.7 0-1.2-0.6-1.3-1.1l-1.3-4.8c0 0-0.1-0.1-0.2-0.2l-3.1-1.3c-0.1 0-0.3 0-0.3 0l-4.3 2.5c-0.5 0.3-1.2 0.2-1.7-0.2 0 0-0.7-0.6-1.3-1.2 -0.6-0.6-1.2-1.3-1.2-1.3 -0.4-0.5-0.4-1.2-0.2-1.7l2.5-4.3c0 0 0-0.2 0-0.2l-1.3-3.1c0-0.1-0.1-0.2-0.2-0.2l-4.8-1.3C0.5 24.5 0 23.9 0 23.3L0 19.9c0-0.6 0.5-1.2 1.1-1.4l4.8-1.3c0.1 0 0.2-0.1 0.2-0.2l1.3-3.1c0-0.1 0-0.2 0-0.3L4.9 9.4c-0.3-0.5-0.2-1.2 0.2-1.7 0 0 0.6-0.8 1.2-1.3C6.8 5.9 7.5 5.3 7.5 5.3 8 4.9 8.7 4.8 9.2 5.1l4.3 2.5c0 0 0.2 0 0.2 0l3.1-1.3c0.1 0 0.2-0.2 0.2-0.2l1.3-4.9C18.5 0.7 19 0 19.7 0h3.4c0.7 0 1.2 0.7 1.4 1.2l1.3 5c0 0 0.1 0.2 0.2 0.2l3.1 1.3c0.1 0.1 0.3 0 0.3 0l4.3-2.5c0.5-0.3 1.2-0.2 1.7 0.2 0 0 0.8 0.6 1.3 1.2 0.5 0.5 1.2 1.3 1.2 1.3 0.4 0.5 0.4 1.2 0.2 1.7l-2.5 4.3c0 0 0 0.2 0 0.2l1.3 3c0 0.1 0.1 0.2 0.2 0.2l4.8 1.3c0.6 0.2 1 0.7 1.1 1.3l0 3.4c0 0.6-0.5 1.2-1.1 1.4l-4.8 1.3c-0.1 0-0.2 0.1-0.2 0.2l-1.3 3.1c0 0.1 0 0.2 0 0.3l2.5 4.3c0.3 0.5 0.2 1.2-0.2 1.7 0 0-0.6 0.8-1.2 1.3 -0.6 0.6-1.3 1.2-1.3 1.2 -0.4 0.4-1.2 0.4-1.7 0.1l-4.3-2.5c0 0-0.2 0-0.2 0l-3.1 1.3c-0.1 0-0.2 0.1-0.2 0.2l-1.3 4.8C24.2 42.5 23.7 43.1 23 43.1zM19.7 41.7h3.3c0 0 0 0 0-0.1l1.3-4.8c0.1-0.5 0.6-1 1.1-1.2l3-1.2c0.2-0.1 0.5-0.1 0.7-0.1 0.3 0 0.6 0.1 0.8 0.2l4.3 2.5c0 0 0.7-0.6 1.3-1.1 0.5-0.5 1.1-1.2 1.1-1.2l-2.5-4.4c-0.3-0.5-0.3-1.1 0-1.6l1.2-3c0.2-0.5 0.6-0.9 1.1-1l4.8-1.3 0-3.4 -4.8-1.3c-0.5-0.1-1-0.6-1.2-1.1l-1.2-3c-0.2-0.4-0.2-1.1 0.1-1.5l2.5-4.3c0 0-0.6-0.7-1.1-1.2 -0.5-0.5-1.2-1.1-1.2-1.1l-4.4 2.5c-0.2 0.1-0.5 0.2-0.8 0.2 -0.2 0-0.5 0-0.8-0.2l-3-1.2c-0.4-0.1-0.9-0.6-1-1.1l-1.3-5c0 0 0-0.1-0.1-0.1h-3.2c0 0-0.1 0.1-0.1 0.1l-1.3 4.9c-0.1 0.5-0.6 1-1.1 1.2l-3 1.2c-0.2 0.1-0.5 0.1-0.7 0.1 -0.3 0-0.6-0.1-0.8-0.2L8.5 6.4c0 0-0.7 0.6-1.2 1.1C6.7 8 6.1 8.7 6.1 8.7h0c0 0 0 0 0 0.1l2.4 4.3c0.3 0.5 0.3 1.1 0 1.6l-1.2 3c-0.1 0.5-0.6 0.9-1.2 1l-4.8 1.3L1.4 23.3l4.8 1.3c0.5 0.1 1 0.6 1.2 1.1l1.2 3c0.2 0.4 0.2 1.1-0.1 1.5l-2.5 4.3c0 0 0.6 0.7 1.1 1.3 0.5 0.5 1.2 1.1 1.2 1.1l4.4-2.5c0.5-0.3 1.1-0.3 1.6 0l3 1.2c0.4 0.2 0.9 0.6 1 1.1l1.3 4.9C19.7 41.6 19.7 41.7 19.7 41.7zM21.4 29.1c-2 0-3.9-0.8-5.3-2.2 -1.4-1.4-2.2-3.3-2.2-5.3 0-2 0.8-3.8 2.2-5.2 1.4-1.4 3.3-2.2 5.2-2.2 2 0 3.9 0.8 5.3 2.2 1.4 1.4 2.2 3.3 2.2 5.2 0 2-0.8 3.8-2.2 5.2C25.2 28.3 23.3 29.1 21.4 29.1zM21.4 15.7c-1.6 0-3.1 0.6-4.2 1.7 -1.1 1.1-1.8 2.6-1.8 4.2 0 1.6 0.6 3.1 1.7 4.2 1.1 1.1 2.6 1.8 4.2 1.8 1.6 0 3.1-0.6 4.2-1.7 1.1-1.1 1.8-2.6 1.8-4.2 0-1.6-0.6-3.1-1.7-4.2C24.5 16.3 23 15.7 21.4 15.7z"
            />
          </svg>
          ניהול חשבון
        </h1>
      </div>
      <div class="column has-text-centered">
        <div class="status">
          <img :src="levelImg" :alt="$store.state.user.name" />
          <span>{{ $store.state.user.accountStatus }}</span>
        </div>
        <a
          href="https://yoganow.co.il/%D7%A9%D7%99%D7%A8%D7%95%D7%AA-%D7%9C%D7%A7%D7%95%D7%97%D7%95%D7%AA"
          class="yoga-btn yoga-icon-btn"
          style="margin-top: 1rem"
        >
          <span class="icon is-medium">
            <i class="mdi mdi-18px mdi-help-circle-outline"></i>
          </span>
          שירות לקוחות
        </a>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth-desktop">
        <div class="account-info" v-if="!$store.state.user.hasToken">
          <h5>תאריך סיום המנוי</h5>
          <span>{{ $store.state.user.nextPayment }}</span>
        </div>
        <div class="account-info" v-else>
          <h5>תאריך החיוב הבא</h5>
          <span>{{ $store.state.user.nextPayment }}</span>
        </div>
        <a
          href="https://yoganow.co.il/%D7%A9%D7%99%D7%A0%D7%95%D7%99-%D7%A1%D7%99%D7%A1%D7%9E%D7%94"
          class="yoga-btn-beige"
        >
          שינוי סיסמה
        </a>
      </div>

      <div class="column is-one-quorter-desktop">
        <div class="account-info">
          <h5>סוג מנוי</h5>
          <span>{{ subType }}</span>
          <a
            href="#"
            class="change-account"
            @click.prevent="toggleAccountTypeDialog"
            >(שנה סוג מנוי)</a
          >
        </div>

        <form :action="editCardUrl" method="post">
          <input
            type="hidden"
            name="editCard"
            :value="$store.state.user.subType"
          />
          <input
            type="submit"
            value="עריכת פרטי אשראי"
            class="yoga-btn-beige"
          />
        </form>
      </div>
    </div>

    <hr />

    <checkbox-container
      label="ניהול התראות"
      :options="emailConfig"
      config="emailConfig"
    ></checkbox-container>

    <button class="yoga-btn-beige" @click="saveConfig(`emailConfig`)">
      שמור שינויים
    </button>

    <hr />

    <checkbox-container
      label="שלחו לי תזכורת להתאמן בימים"
      :options="remindersConfig"
      config="remindersConfig"
    ></checkbox-container>

    <button class="yoga-btn-beige" @click="saveConfig(`remindersConfig`)">
      שמור שינויים
    </button>

    <hr />

    <div class="account-buttons">
      <a href="https://yoganow.co.il/?&service=logout" class="yoga-btn-beige">
        <span class="icon is-medium">
          <i class="mdi mdi-18px mdi-account-outline"></i>
        </span>
        התנתק
      </a>
    </div>

    <div class="cancel-account">
      <router-link class="yoga-btn-beige" :to="{ name: 'feedback' }">
        בטל מנוי
      </router-link>

      <!-- <button class="yoga-btn-beige">
            סגור חשבון
        </button> -->
    </div>
    <account-dialog
      v-if="dialog"
      v-on:close-dialog="toggleAccountTypeDialog"
    ></account-dialog>
  </div>
</template>

<script>
import CheckboxContainer from "@/components/account/CheckboxContainer.vue";
import AccountDialog from "@/components/account/AccountDialog.vue";

export default {
  name: `AccountPage`,

  components: {
    CheckboxContainer,
    AccountDialog,
  },

  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    levelImg() {
      if (this.$store.state.user.level) {
        return `${this.$store.state.initialData.basepath}assets/yoga/images/app/levels/${this.$store.state.user.level}.png`;
      }
      return ``;
    },
    emailConfig() {
      return this.$store.state.user.emailConfig;
    },
    remindersConfig() {
      return this.$store.state.user.remindersConfig;
    },
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    subType() {
      const sub = this.$store.state.user.subType;
      if (parseInt(sub, 10) === 2) {
        return `שנתי`;
      }
      if (parseInt(sub, 10) === 3) {
        return `מורה`;
      }
      if (parseInt(sub, 10) === 4) {
        return `מתנה`;
      }
      return `חודשי`;
    },
    editCardUrl() {
      return `${process.env.VUE_APP_API_POST_EDITCREDICARD}`;
    },
  },

  methods: {
    saveConfig(conf) {
      this.$store.dispatch(`setConfig`, conf);
    },

    toggleAccountTypeDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss">
$purple: #656b85;
$black: #191919;
$white: #ffffff;

.account-page {
  .columns {
    margin-right: 0;
  }
  h1 {
    margin: 20px 0;
  }

  .status {
    padding-top: 30px;
    span {
      font-size: 18px;
      position: relative;
      bottom: 10px;
      color: $black;
      font-weight: normal;
    }
  }

  .yoga-icon-btn {
    .mdi {
      color: #ffffff;
      &:hover {
        color: #fd7170;
      }
    }
  }

  h5 {
    font-weight: bold;
    color: $purple;
    font-size: 18px;
  }
  span {
    color: $purple;
    font-weight: 300;
  }
}

.account-info {
  margin-bottom: 15px;

  .change-account {
    font-size: 0.85rem;
    color: $purple;
    text-decoration: underline;
    margin-right: 3px;
  }
}

.checkbox-container {
  margin-bottom: 30px;
  padding: 0 15px;
}

.yoga-btn-beige {
  margin-right: 15px;

  span {
    color: $white;
  }

  &:hover {
    span {
      color: #a39481;
    }
  }
}

.checkbox {
  font-size: 18px;
  color: $purple;
  font-weight: 300;
  display: inline-block;
  margin-left: 25px;
  margin-top: 15px;
  .checkbox-input {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid $purple;
    background-color: transparent;
    position: relative;
    color: $white;
    .mdi {
      position: absolute;
      top: -7px;
      left: 1px;
      width: 18px;
      height: 18px;
      opacity: 0;
      font-size: 21px;
    }
    &:focus {
      outline: transparent;
    }
  }

  .checkbox-input-selected {
    background-color: $purple;
    .mdi {
      opacity: 1;
    }
  }
}

.cancel-account {
  text-align-last: left;
  padding-top: 50px;
  margin-bottom: 30px;
  padding-left: 15px;
  .yoga-btn-beige {
    margin-right: 20px;
  }
}

.account-buttons {
  text-align: left;
  .yoga-btn-beige {
    margin-right: 10px;
  }
}

@media screen and (min-width: 1025px) {
  .account-page {
    .columns {
      margin-right: -0.75rem;
    }
  }
  .checkbox-container {
    padding: 0;
  }

  .yoga-btn-beige {
    margin-right: 0;
  }
  .cancel-account {
    padding-left: 0;
  }
}
</style>
